

const Position = () => {
  return (
    <h2>Position</h2>
  )
}

export default Position